import * as React from 'react';
import styled from 'react-emotion';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import history from "../../utils/history";
import "bulma/css/bulma.css";
import {Button, Icon} from "bloomer";

const Container = styled("div")`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: 20px minmax(80vh, auto) minmax(19vh, auto);
  min-height: 100vh;

  @media (max-width: 1024px) {
    grid-template-rows: 20px auto;
  }
`;

const ContentOuter = styled("div")`
  margin-top: 70px;
  grid-column: 3/11;
  @media (max-width: 1024px) {
    grid-column: 2/12;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    grid-column: 1/-1;
  }
`;

const Content = styled("div")`
  margin: 0 20px;
  grid-column: 3/11;
  @media (max-width: 1024px) {
    grid-column: 2/12;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    grid-column: 1/-1;
  }
`;

const BackButtonContainer = styled("div")`
    text-align: left;
    color: #2f3241;
    margin-bottom: 20px;
    margin-left: 10px;
    width: 100%;
`;

interface IRequestModelProps {
    openContactForm: any;
}

interface IRequestModelState {
    loading: boolean;
}

class RequestModel extends React.Component<IRequestModelProps, IRequestModelState> {

    public GOOGLE_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSeJWlVqlm6nyKx2jFruxlQGEadR8DYn4NwjVOS14ubOpcxXxA/viewform?embedded=true&hl=en";

    public constructor(props: IRequestModelProps) {
        super(props);

        this.state = {
            loading: true
        };
    }

    public render() {
        return <Container>
            <Header history={history}/>
            <ContentOuter>
                <BackButtonContainer>
                    <Button
                        style={{
                            border: 0,
                            color: "#1c2541"
                        }}
                        title="Go To Dashboard"
                        onClick={(e: any) => {
                            e.target.blur();
                            history.push("/models");
                        }}
                    >
                        <Icon className="fas fa-arrow-left" style={{marginRight: "5px"}}/>Go Back
                    </Button>
                </BackButtonContainer>
                <Content>
                    {
                        this.state.loading ? <div style={{textAlign: 'center'}}>
                            <span>Loading...</span>
                            <Icon className="fas fa-spinner fa-spin"/>
                        </div> : <></>
                    }
                    <iframe
                        onLoad={() => {
                            this.setState({
                                loading: false
                            });
                        }}
                        style={{
                            width: '100%',
                            height: '1400px',
                            overflowX: 'hidden'
                        }}
                        src={this.GOOGLE_FORM_URL}
                        frameBorder="0"
                        marginHeight={0}
                        marginWidth={0}
                    />
                </Content>
            </ContentOuter>
            <Footer openContactForm={this.props.openContactForm}/>
        </Container>;
    }
}

export default RequestModel;


// WEBPACK FOOTER //
// ./src/routes/RequestModel/index.tsx